import { UsageInterval } from '@/types'
import { format, parseISO, subDays, subYears, formatISO } from 'date-fns'

export const formatPeriod = (period: string | null | undefined, interval: UsageInterval) => {
  if (!period) return '—'
  
  try {
    const date = parseISO(period)
    
    switch (interval) {
      case 'MINUTE':
        return format(date, 'HH:mm')
      case 'HOUR':
        return format(date, 'HH:mm')
      case 'DAY':
        return format(date, 'MM/dd/yyyy')
      case 'WEEK':
        return format(date, 'MM/dd/yyyy')
      case 'MONTH':
        return format(date, 'MMM yyyy')
      default:
        return format(date, 'MM/dd/yyyy')
    }
  } catch {
    return '—'
  }
}

// Function to calculate date range based on time period
export const getDateRange = (timeRange: string): { startDate: string; endDate: string } => {
  const now = new Date()
  
  const startDate = (() => {
    switch (timeRange) {
      case '7d': return subDays(now, 7)
      case '30d': return subDays(now, 30)
      case '90d': return subDays(now, 90)
      case '1y': return subYears(now, 1)
      default: return subDays(now, 7)
    }
  })()

  return {
    startDate: formatISO(startDate),
    endDate: formatISO(now)
  }
}

export const formatDate = (date: Date | string | null | undefined) => {
  if (!date) return '—'
  const d = typeof date === 'string' ? new Date(date) : date
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('en-US')
}

export const formatDateTime = (date: Date | string | null | undefined) => {
  if (!date) return '—'
  const d = typeof date === 'string' ? new Date(date) : date
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleString('en-US')
}

export const formatTime = (date: Date | string | null | undefined) => {
  if (!date) return '—'
  const d = typeof date === 'string' ? new Date(date) : date
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleTimeString('en-US')
} 